import { ColDef } from "ag-grid-community";
import { formatNumber } from "~utils/NumberFormatter.ts";

const DEFAULT_MAXIMUM_FRACTION_DIGITS = 2;
const DEFAULT_MINIMUM_FRACTION_DIGITS = 0;

/**
 * Number column type for the ag-grid.
 */
export const NumberColumn: ColDef = {
	filter: "agNumberColumnFilter",
	floatingFilter: true,
	filterParams: {
		maxNumConditions: 10,
	},
	valueParser: (params) => Number(params.newValue.toString().replace(",", ".")),
	valueFormatter: (params) => {
		let maximumFractionDigits = DEFAULT_MAXIMUM_FRACTION_DIGITS;
		let minimumFractionDigits = DEFAULT_MINIMUM_FRACTION_DIGITS;

		if (params.colDef.cellRendererParams && "maximumFractionDigits" in params.colDef.cellRendererParams) {
			maximumFractionDigits = parseInt(params.colDef.cellRendererParams["maximumFractionDigits"], 10);
		}

		if (params.colDef.cellRendererParams && "minimumFractionDigits" in params.colDef.cellRendererParams) {
			minimumFractionDigits = parseInt(params.colDef.cellRendererParams["minimumFractionDigits"], 10);
		}

		if (params.value == null) {
			return "";
		}

		return formatNumber(params.value, maximumFractionDigits, minimumFractionDigits);
	},
};
